import "./style.scss";

import Alpine from "alpinejs";

// @ts-ignore
import collapse from "@alpinejs/collapse";

// @ts-ignore
import Swiper, { Navigation } from "swiper";
import "swiper/css";

import noUiSlider from "nouislider";
import "swiper/css/navigation";
import "nouislider/dist/nouislider.css";

//import mapboxgl from "mapbox-gl";
//import "mapbox-gl/dist/mapbox-gl.css";

Alpine.plugin(collapse);

window.Alpine = Alpine; // Needed for devtools to work on Alpine 3
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {

    new Swiper(".swiper-1", {
        breakpoints: {
            320: {
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                slidesPerView: 1.7,
                spaceBetween: 20,
            },
            1024: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });

});

new Swiper(".swiper-2", {
    slidesPerView: 1,
    breakpoints: {
        320: {
            spaceBetween: 20,
        },
        1024: {
            spaceBetween: 30,
        },
    },
    pagination: {
        el: ".swiper-2-pagination",
    },
    navigation: {
        prevEl: ".swiper-2-button-prev",
        nextEl: ".swiper-2-button-next",
    },
    modules: [Navigation],
});

const ranges = document.getElementsByClassName("range") as HTMLCollectionOf<HTMLElement>;

for (const range of ranges) {

    const min = parseInt(range.dataset.min || "0");
    const max = parseInt(range.dataset.max || "1000");

    const slider = noUiSlider.create(range, {
        start: [min, max],
        step: 1,
        connect: true,
        range: {
            min,
            max,
        },
    });

    slider.on("slide", function (values) {
        const el = document.getElementById(range.id);
        if (el) {
            el.dispatchEvent(new CustomEvent('range', { detail: { lower: Math.floor(values[0] as number), upper: Math.floor(values[1] as number) } }));
        }
    });

}

// map

//const mapContainer = document.getElementById("map");

//if (mapContainer) {

//    mapboxgl.accessToken = "pk.eyJ1Ijoia2VubmV0aC1zb2xiZXJnIiwiYSI6ImNsaDBqMGJiNDB0d3oza3J6bG4yZmwzcjYifQ.RzqmGDR2b7nJ33brpyAt-Q";

//    const map = new mapboxgl.Map({
//        container: mapContainer.id,
//        style: "mapbox://styles/mapbox/light-v10",
//        center: [10.459840198456542, 61.11681922169808],
//        zoom: 12,
//    });

//    new mapboxgl.Marker({ color: "black" }).setLngLat([10.459840198456542, 61.11681922169808]).addTo(map);

//    map.scrollZoom.disable();
//    map.doubleClickZoom.disable();
//    map.touchZoomRotate.disable();
//    map.boxZoom.disable();
//    map.dragRotate.disable();
//    map.keyboard.disable();

//    const nav = new mapboxgl.NavigationControl({
//        showCompass: false,
//    });

//    map.addControl(nav, "bottom-right");
//}

// @ts-ignore
window.onYouTubeIframeAPIReady = function () {
    // @ts-ignore
    window.youTubeIframeAPIReady = true;
}
